import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "@env";
import {
  PartManufactirerFindByFiltersDTO,
  PartManufacturerDTO
} from "@shared/models/part-manufacturer-dto";

@Injectable({
  providedIn: "root"
})
export class PartManufacturerService {
  private partManufacturerUrl = "part-manufacturers";

  constructor(private http: HttpClient) {}

  findByFilters(
    searchFormDTO: PartManufactirerFindByFiltersDTO
  ): Observable<PartManufacturerDTO[]> {
    let query = "?";
    if (searchFormDTO.name) {
      query +=`name=${searchFormDTO.name}`;
    }
    return this.http.get<PartManufacturerDTO[]>(
      environment.microserviceParts + `${this.partManufacturerUrl}${query}`
    );
  }

  save(partManufacturerDTO: PartManufacturerDTO): Observable<any> {
    return this.http.post<any>(
      `${environment.microserviceParts}${this.partManufacturerUrl}`,
      partManufacturerDTO
    );
  }

  listAll(): Observable<PartManufacturerDTO[]> {
    return this.http.get<PartManufacturerDTO[]>(
      `${environment.microserviceParts}${this.partManufacturerUrl}`
    );
  }

  delete(id: number): Observable<any> {
    return this.http.delete<any>(
      `${environment.microserviceParts}${this.partManufacturerUrl}/${id}`
    );
  }

  findById(id: number): Observable<PartManufacturerDTO> {
    return this.http.get<PartManufacturerDTO>(
      `${environment.microserviceParts}${this.partManufacturerUrl}/${id}`
    );
  }

  edit(id: number, partManufacturerDTO: PartManufacturerDTO): Observable<any> {
    return this.http.put<any>(
      `${environment.microserviceParts}${this.partManufacturerUrl}/${id}`,
      partManufacturerDTO
    );
  }
}
